import type { Component } from 'vue'
import PaypalGateway from '@/components/Payments/PaypalGateway.vue'
import AdyenGateway from '@/components/Payments/AdyenGateway.vue'
import OtherGateway from '@/components/Payments/OtherGateway.vue'
import CryptoGateway from '@/components/Payments/CryptoGateway.vue'
import StripeGateway from '@/components/Payments/StripeGateway.vue'

type GatewayType = 'card' | 'paypal' | 'crypto' | 'other'

interface GatewayOptions {
  adyenEnabled?: boolean
  paypalEnabled?: boolean
  stripeSafeBadges?: boolean
  cryptoPaymentEnabled?: boolean
  alipayEnabled?: boolean
  wechatPayEnabled?: boolean
}

export function createPaymentGateway(
  type: GatewayType,
  options: GatewayOptions = {},
): Component | null {
  switch (type) {
    case 'card':
      return options.adyenEnabled ? AdyenGateway : StripeGateway
    case 'paypal':
      return options.paypalEnabled ? PaypalGateway : null
    case 'crypto':
      return options.cryptoPaymentEnabled ? CryptoGateway : null
    case 'other':
      return options.alipayEnabled || options.wechatPayEnabled ? OtherGateway : null
    default:
      return null
  }
}
